import AllChats from "./AllChats";
import TypeChat from "./TypeChat";

const Chat = () => {
  return (
    <div className="h-100">
      <AllChats />
      <TypeChat />
    </div>
  );
};

export default Chat;
